import { Input, Icon, DatePicker, Menu, Dropdown } from 'antd';
import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';

import './EditableCell.css';


export const EDITABLE_CELL_TYPES = {
  TEXT: 0,
  MULTILINE_TEXT: 1,
  DATE: 2,
  ENUM: 3,
  IMAGE: 4,
  TUPLE: 5,
  ENUM_OBJECT: 6,
  DATE_TIME: 7
};


export default class EditableCell extends React.Component {
  state = {
    value: this.props.value,
    editable: false,
    type: this.props.type,
    menu: this.props.menu
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  handleChange = (e, index) => {
    const { type } = this.state;
    let old_value = this.state.value;
    let value;
    switch (type) {
      case EDITABLE_CELL_TYPES.TEXT:
      case EDITABLE_CELL_TYPES.MULTILINE_TEXT:
        value = e.target.value;
        break;
      case EDITABLE_CELL_TYPES.DATE:
      case EDITABLE_CELL_TYPES.DATE_TIME:
      case EDITABLE_CELL_TYPES.ENUM:
      case EDITABLE_CELL_TYPES.ENUM_OBJECT:
        value = e;
        break;
      case EDITABLE_CELL_TYPES.IMAGE:
        value = e.target.files[0];
        break;
      case EDITABLE_CELL_TYPES.TUPLE:
        value = old_value.split(',');
        value[index] = e.target.value;
        value = value.join();
    }
    this.setState({ value });
  };

  check = () => {
    this.setState({ editable: false });
    if (this.props.onChange) {
      switch (this.state.type) {
        case EDITABLE_CELL_TYPES.IMAGE:
          if (!(typeof this.state.value === 'string')) this.props.onChange(this.state.value);
          break;
        default:
          this.props.onChange(this.state.value);
      }
    }
  };

  edit = () => {
    this.setState({ editable: true });
  };


  renderField() {
    const { value, type } = this.state;
    switch (type) {
      case EDITABLE_CELL_TYPES.TEXT:
      case EDITABLE_CELL_TYPES.MULTILINE_TEXT:
        return <div className="editable-cell-input-wrapper respect-whitespaces">
          {value || '-'}
          <Icon
            type="edit"
            className="editable-cell-icon"
            onClick={this.edit}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.TUPLE:
        return <div className="editable-cell-input-wrapper respect-whitespaces">
          {value ? value.split(',').join(', ') : '-'}
          <Icon
            type="edit"
            className="editable-cell-icon"
            onClick={this.edit}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.DATE:
        return <div className="editable-cell-input-wrapper">
          {value ? moment(value).format('ll') : '-'}
          <Icon
            type="edit"
            className="editable-cell-icon-check"
            onClick={this.edit}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.DATE_TIME:
        return <div className="editable-cell-input-wrapper">
          {value ? moment(value).format('lll') : '-'}
          <Icon
            type="edit"
            className="editable-cell-icon-check"
            onClick={this.edit}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.ENUM:
        return <div className="editable-cell-input-wrapper">
          {value || '-'}
          <Icon
            type="edit"
            className="editable-cell-icon-check"
            onClick={this.edit}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.ENUM_OBJECT:
        return <div className="editable-cell-input-wrapper">
          {value && value.name ? value.name : '-'}
          <Icon
            type="edit"
            className="editable-cell-icon-check"
            onClick={this.edit}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.IMAGE:
        return <div className="editable-cell-input-wrapper">
          {((typeof value === 'string') && (value !== '')) ? <img className='avatar' src={value}/> : '-'}
          <Icon
            type="edit"
            className="editable-cell-icon-check"
            onClick={this.edit}
          />
        </div>;
        break;
      default:
        break;
    }
  }

  renderEditable() {
    const { value, type, menu } = this.state;
    switch (type) {
      case EDITABLE_CELL_TYPES.TEXT:
        return <div className="editable-cell-input-wrapper">
          <Input
            value={value}
            onChange={this.handleChange}
            onPressEnter={this.check}
          />
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.MULTILINE_TEXT:
        return <div className="editable-cell-input-wrapper">
          <textarea
            className='wide-textarea'
            value={value ? value : ""}
            rows={5}
            onChange={this.handleChange}
          />
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.TUPLE:
        const values = value.split(',');
        return <div className="editable-cell-input-wrapper">
          <Input
            className='narrow-input'
            value={values[0]}
            onChange={(e) => this.handleChange(e, 0)}
          />
          <Input
            className='narrow-input'
            value={values[1]}
            onChange={(e) => this.handleChange(e, 1)}
          />
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.DATE:
        return <div className="editable-cell-input-wrapper">
          <DatePicker value={value ? moment(value) : moment()}
                      onChange={this.handleChange}
                      format={'YYYY/MM/DD'}/>
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.DATE_TIME:
        return <div className="editable-cell-input-wrapper">
          <DatePicker value={value ? moment(value) : moment()}
                      onChange={this.handleChange}
                      showTime
                      format={'YYYY/MM/DD HH:mm:ss'}/>
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.ENUM:
        const _menu = _.map(menu, (item) => <Menu.Item key={item}>
          <a
            target={item}
            rel="noopener noreferrer"
            onClick={() => this.handleChange(item)}
          >{item}</a>
        </Menu.Item>);
        const __menu = <Menu>{_menu}</Menu>;
        return <div className="editable-cell-input-wrapper">
          <Dropdown overlay={__menu}>
            <a className="ant-dropdown-link"
               href="#">
              {value || '-'}<Icon type="down"/>
            </a>
          </Dropdown>
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.ENUM_OBJECT:
        const _objMenu = _.map(menu, (item) => <Menu.Item key={item.id}>
          <a
            target={item.name}
            rel="noopener noreferrer"
            onClick={() => this.handleChange(item)}
          >{item.name}</a>
        </Menu.Item>);
        const __objMenu = <Menu>{_objMenu}</Menu>;
        return <div className="editable-cell-input-wrapper">
          <Dropdown overlay={__objMenu}>
            <a className="ant-dropdown-link"
               href="#">
              {value.name || '-'}<Icon type="down"/>
            </a>
          </Dropdown>
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
        break;
      case EDITABLE_CELL_TYPES.IMAGE:
        return <div className="editable-cell-input-wrapper">
          <input type="file"
                 onChange={this.handleChange}/>
          <Icon
            type="check"
            className="editable-cell-icon-check"
            onClick={this.check}
          />
        </div>;
      default:
        break;
    }
  }

  render() {
    const { editable } = this.state;
    return (
      <div className="editable-cell">
        {editable ? this.renderEditable() : this.renderField()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/editable-cell/EditableCell.jsx